import { useEffect } from "react";
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import { StoreType } from "./types";

interface AuthRouteProps {
	authenticated: boolean;
	workerApp: boolean;
}

const FULL_TIME_SCHEDULE_PATH = "/full-time-schedule";

const AuthRoute = ({ authenticated, workerApp }: AuthRouteProps) => {
	const ftSchedulerEnabled = useSelector(
		(state: StoreType) => state.user.userData.ftSchedulerEnabled
	);
	const ftSchedulerEnabledLocations = useSelector(
		(state: StoreType) => state.user.userData.ftSchedulerEnabledLocations
	);
	// const history = useHistory()
	// console.log('IN AuthRoute: ', Component, ' workerAPp; ', workerApp, ' authenticated: ', authenticated)
	useEffect(() => {
		return () => {
			if (localStorage.getItem("login-redirect")) {
				// console.log('removing login-redirect')
				localStorage.removeItem("login-redirect");
			}
		};
	}, []);

	// try.wilya.com: supervisors who can use the full-time scheduler land on
	// it after login. Others keep "/", since the scheduler page itself sends
	// users without it back to "/".
	const canUseFullTimeScheduler =
		process.env.REACT_APP_ENV === "try-wilya" &&
		ftSchedulerEnabled &&
		(ftSchedulerEnabledLocations?.length ?? 0) > 0;
	const defaultLanding = canUseFullTimeScheduler
		? FULL_TIME_SCHEDULE_PATH
		: "/";
	const loginRedirect = localStorage.getItem("login-redirect") || defaultLanding;

	if (workerApp) {
		return authenticated ? <Navigate to='/w' replace /> : <Outlet />;
	}

	return authenticated ? <Navigate to={loginRedirect} replace /> : <Outlet />;
};

export default AuthRoute;
